<template>
  <div>
    <my-notification :icon="'shield'">
      <template #title>
        {{ $t('compCarbonDocsDataProtection.title') }}
      </template>
      <span v-html="$t('compCarbonDocsDataProtection.text-1')" />
      <br />
      <span v-html="$t('compCarbonDocsDataProtection.text-2')" />
      <br />
      <br />
      <span v-html="$t('compCarbonDocsDataProtection.text-3')" />
      <br />
      <span v-html="$t('compCarbonDocsDataProtection.text-4')" />
      <br />
      <br />
      <span v-html="$t('compCarbonDocsDataProtection.text-5')" />
    </my-notification>
  </div>
</template>

<script>
export default {
  name: 'DataProtection',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue')
  }
}
</script>

<style lang="css" scoped>
.bcteam {
  list-style-type: square;
  margin-left: 25px;
}
.bcteam > li {
  padding-top: 5px;
}
</style>
